import script from "./searchHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./searchHeader.vue?vue&type=script&setup=true&lang=ts"

import "./searchHeader.vue?vue&type=style&index=0&id=04c32b55&lang=less&scoped=true"

import exportComponent from "/builds/mocean/cms/cms-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-04c32b55"]])

export default __exports__